<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="科室名称" prop="departId" >
        <a-input-search
          v-model="departName"
          placeholder="请选择科室"
          enter-button="选择"
          @search="handleSelectDepart"
          :readonly="true"
        />
        <table-select-modal
          :visible.sync="departSelectVisible"
          title="选择科室"
          :api-method="pageDepart"
          :columns="departColumns"
          search-label="科室名称"
          search-key="name"
          search-placeholder="请输入科室名称"
          :data-path="'data.records'"
          :total-path="'data.total'"
          @ok="handleDepartSelected"
          @cancel="handleDepartCancel"
        >
        </table-select-modal>
      </a-form-model-item>
      <a-form-model-item label="病症名称" prop="diseaseId" >
        <a-input-search
          v-model="diseaseName"
          placeholder="请选择病症"
          enter-button="选择"
          @search="handleSelectDisease"
          :readonly="true"
        />
        <table-select-modal
          :visible.sync="diseaseSelectVisible"
          title="选择病症"
          :api-method="pageDisease"
          :columns="diseaseColumns"
          search-label="病症名称"
          search-key="diseaseName"
          search-placeholder="请输入病症名称"
          :data-path="'data.records'"
          :total-path="'data.total'"
          @ok="handleDiseaseSelected"
          @cancel="handleDiseaseCancel"
        >
        </table-select-modal>
      </a-form-model-item>
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDepartLink, addDepartLink, updateDepartLink } from '@/api/disease/departLink'
import {pageDepart} from "@/api/depart/depart";
import {pageDisease} from "@/api/disease/disease";
import TableSelectModal from '@/components/TableSelectModal'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    TableSelectModal
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      departName: '',
      diseaseName: '',
      departSelectVisible: false,
      diseaseSelectVisible: false,
      // 表单参数
      form: {
        id: null,

        departId: null,

        diseaseId: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        departId: [
          { required: true, message: '科室不能为空', trigger: 'blur' }
        ],
        diseaseId: [
          { required: true, message: '疾病不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    // 动态生成科室表格列
    departColumns() {
      return [
        {
          title: '科室名称',
          dataIndex: 'name',
          ellipsis: true,
          width: 200
        }
      ]
    },
    // 动态生成病症表格列
    diseaseColumns() {
      return [
        {
          title: '病症名称',
          dataIndex: 'diseaseName',
          ellipsis: true,
          width: 200
        }
      ]
    }
  },
  filters: {
  },
  created () {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    pageDepart,
    pageDisease,

    // 打开科室选择弹窗
    handleSelectDepart () {
      this.departSelectVisible = true
    },

    // 科室选择确定
    handleDepartSelected (depart) {
      this.form.departId = depart.id
      this.departName = depart.name
      this.departSelectVisible = false
    },

    // 科室选择取消
    handleDepartCancel () {
      this.departSelectVisible = false
    },

    // 打开病症选择弹窗
    handleSelectDisease () {
      this.diseaseSelectVisible = true
    },

    // 病症选择确定
    handleDiseaseSelected (disease) {
      this.form.diseaseId = disease.id
      this.diseaseName = disease.diseaseName
      this.diseaseSelectVisible = false
    },

    // 病症选择取消
    handleDiseaseCancel () {
      this.diseaseSelectVisible = false
    },

    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.departName = ''
      this.diseaseName = ''
      this.form = {
        id: null,
        departId: null,
        diseaseId: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDepartLink({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
        // 回显科室名称
        if (this.form.departId) {
          this.loadDepartName(this.form.departId)
        }
        // 回显病症名称
        if (this.form.diseaseId) {
          this.loadDiseaseName(this.form.diseaseId)
        }
      })
    },

    // 加载科室名称用于回显
    loadDepartName(departId) {
      pageDepart({ id: departId, pageNum: 1, pageSize: 1 }).then(res => {
        if (res.data && res.data.records && res.data.records.length > 0) {
          this.departName = res.data.records[0].name
        }
      })
    },

    // 加载病症名称用于回显
    loadDiseaseName(diseaseId) {
      pageDisease({ id: diseaseId, pageNum: 1, pageSize: 1 }).then(res => {
        if (res.data && res.data.records && res.data.records.length > 0) {
          this.diseaseName = res.data.records[0].diseaseName
        }
      })
    },

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDepartLink(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDepartLink(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
